export default "__VITE_ASSET__f4ddda1f__"